import React from 'react';
import { Tabs } from './Tabs';
import type { TabsProps } from 'react-aria-components';
import { useQueryDataTableOptions } from '~/shared/data-tables/query/useQueryDataTableOptions';
import { parseAsString, useQueryState } from 'nuqs';

export function QueryParamTabs({
	paramName = 'selectedTab',
	defaultTab,
	clearRemainingParams = false,
	...props
}: Omit<TabsProps, 'selectedKey' | 'onSelectionChange' | 'children'> & {
	paramName?: string;
	defaultTab: string;
	clearRemainingParams?: boolean;
	children: ((selected: string) => React.ReactNode) | React.ReactNode;
}) {
	const [selectedTab, setSelectedTab] = useQueryState(paramName, parseAsString.withDefault(defaultTab));
	const { clearSearchOptions } = useQueryDataTableOptions();

	const handleOnTabClick = (newSelectedTab: string) => {
		if (clearRemainingParams) {
			clearSearchOptions();
		}
		setSelectedTab(newSelectedTab);
	};

	return (
		<Tabs selectedKey={selectedTab} onSelectionChange={handleOnTabClick} {...props}>
			{typeof props.children === 'function' ? props.children(selectedTab) : props.children}
		</Tabs>
	);
}
